import { createContext } from 'react'

export interface GlobalState {
  device: string | null
}

export const GlobalContext = createContext<GlobalState>({
  device: null,
})
